import React from 'react';
import './style.scss';
import Component from './component';
import { Input, Icon, Button, Form, Select, Spin } from 'udesk-ui';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Ellipsis from 'src/components/common/Ellipsis';
import { InView } from 'react-intersection-observer';
import UdeskLocales from 'UdeskLocales';

const { TextArea } = Input;
const { Option } = Select;

export default class AiReportTemplate extends Component {
    render() {
        let { actions, locales, privates } = this;

        // 列表页: 表单 + 历史报告
        const renderListPage = () => (
            <div className="ai-report-container">
                {/* 上方表单 - 固定高度 */}
                <div className="ai-report-form-section">
                    <Form
                        ref={privates.formRef}
                        onValuesChange={actions.onFormChange}
                        initialValues={privates.reportParams}
                    >
                        <Form.Item name="taskId">
                            <Select
                                placeholder={/* 选择质检任务 */UdeskLocales['current'].components.smartToolBar.aiReport.template.selectQualityTask}
                                allowClear
                                style={{ width: '100%' }}
                            >
                                {privates.taskList.map((t) => (
                                    <Option key={t.id} value={t.id}>
                                        {t.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="description">
                            <TextArea
                                placeholder={/* 输入报告生成要求 */UdeskLocales['current'].components.smartToolBar.aiReport.template.enterReportGenerationRequirements}
                                rows={4}
                                style={{ resize: 'none' }}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type="primary"
                                onClick={actions.generateReport}
                                style={{ width: '100%' }}
                            >{/* 生成报告 */}{UdeskLocales['current'].components.smartToolBar.aiReport.template.generateReport}</Button>
                        </Form.Item>
                    </Form>
                </div>

                {/* 分隔线 */}
                <div className="ai-report-divider" />

                {/* 下方历史报告列表 - 占据剩余空间 */}
                <div className="ai-report-list-section">
                    <div className="ai-report-list-header">
                        <span>{/* 历史报告 */}{UdeskLocales['current'].components.smartToolBar.aiReport.template.historicalReport}</span>
                    </div>
                    <div className="ai-report-list-content">
                        {privates.reportList.map((item) => {
                            // 状态 1未开始 2导出中 4失败 5完成
                            const status = item.status;
                            const showActions = status === 2 || status === 5;
                            const showStatus = status === 1 || status === 4;
                            const hasResultLink = !!item.resultLink;
                            const statusTextMap = {
                                1: /* 待生成 */UdeskLocales['current'].components.smartToolBar.aiReport.template.toBeGenerated,
                                2: /* 导出中 */UdeskLocales['current'].components.smartToolBar.aiReport.template.exporting,
                                4: /* 生成失败 */UdeskLocales['current'].components.smartToolBar.aiReport.template.failedToGenerate,
                                5: /* 完成 */UdeskLocales['current'].components.smartToolBar.aiReport.template.complete,
                            };
                            return (
                                <div
                                    key={item.id}
                                    className="ai-report-list-item"
                                >
                                    <div className="ai-report-list-item-info">
                                        <div className="ai-report-list-item-name">
                                            {/* {item.taskName} */}
                                            {item.createTime}
                                        </div>
                                        {/* <div className="ai-report-list-item-meta">
                                            <span className="ai-report-list-item-time">
                                                {item.createTime}
                                            </span>
                                            {(status === 1 || status === 4) && (
                                                <span className="ai-report-list-item-status">
                                                    {statusTextMap[status]}
                                                </span>
                                            )}
                                        </div> */}
                                    </div>
                                    <div className="ai-report-list-item-actions">
                                        {showStatus && (
                                            <span className="ai-report-list-item-status">
                                                {statusTextMap[status]}
                                            </span>
                                        )}
                                        {showActions && (
                                            <>
                                            {hasResultLink && (
                                                <Button
                                                    type="link"
                                                    size="small"
                                                    onClick={() => actions.downloadReport(item)}
                                                >
                                                    {locales.labels.download}
                                                </Button>
                                            )}
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={() => actions.viewReport(item)}
                                            >
                                                {locales.labels.view}
                                            </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                        {privates.reportList.length > 0 && (
                            <InView
                                as="div"
                                style={{ minHeight: 1 }}
                                onChange={actions.onReportListInView}
                            >
                                {privates.reportListLoading && (
                                    <div className="ai-report-list-loading">
                                        <Spin size="small" />
                                    </div>
                                )}
                            </InView>
                        )}
                    </div>
                </div>
            </div>
        );

        // 详情页: 报告内容
        const renderDetailPage = () => {
            const report = privates.currentReport;
            if (!report) return null;

            return (
                <div className="ai-report-detail">
                    <div className="ai-report-detail-header">
                        <Button
                            type="text"
                            icon={<Icon type="ic-arrow-left-s-line" />}
                            style={{paddingLeft: 0}}
                            onClick={actions.backToIndex}
                        >
                            {locales.labels.back}
                        </Button>
                        
                        <div className="ai-report-detail-title"><Ellipsis text={report.taskName} /></div>
                        <div className="ai-report-detail-actions">
                            {report.resultLink && (
                                <Button
                                    type="link"
                                    size="small"
                                    onClick={() => actions.downloadReport(report)}
                                >
                                    {locales.labels.download}
                                </Button>
                            )}
                        </div>
                    </div>
                    <div className="ai-report-detail-content">
                        <div className="ai-report-detail-markdown">
                            <ReactMarkdown
                                children={report.content || '-'}
                                remarkPlugins={[remarkGfm]}
                            />
                        </div>
                    </div>
                </div>
            );
        };

        return (
            <div
                className="smart-tools-sider-bar-index-page-drawer-body ai-report-body"
                style={{ height: '100%', padding: 0 }}
            >
                <div className={`ai-report-card${!privates.isFront ? ' flipme' : ''}`}>
                    <div className="ai-report-front">
                        {renderListPage()}
                    </div>
                    <div className="ai-report-back">
                        {renderDetailPage()}
                    </div>
                </div>
            </div>
        );
    }
}
